import { format } from 'date-fns';
import settings from '@/settings.js';
export default function hrDate (value) {
	if (value && value !== null && value !== '') {
		return format(value, settings.viewDtFormat);
	} else {
		return '';
	}
}



// WEBPACK FOOTER //
// ./src/filters/hrDate.js